<nav class="navbar navbar-expand-lg">
    <div class="container">
        <a class="navbar-brand" href="#">
            <img src="assets/images/Blockchain_Logo_Black.png" alt="Polkadog Logo">
        </a>
        <div class="dropdown">
        <div class="btn-section d-flex gap-4">
            <w3m-button balance='hide'></w3m-button>
        </div> 
        </div>
    </div>
</nav>

<div class="modal fade" id="uiWallet" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Connect to Wallet</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- <button class="btn" (click)="connectMetamask()">
                    <img src="assets/images/metamask.svg" width="30px" class="me-2" alt="metamask">
                    <div class="text-dark d-inline-block">Metamask</div>
                </button> -->
              
                <!-- <button class="btn" (click)="connectWallet()">
                    <img src="assets/images/walletconnect-logo.svg" width="30px" class="me-2" alt="TrustWallet">
                    <div class="text-dark d-inline-block">Wallet Connect</div>
                </button> -->
            </div>
         </div>
    </div>
</div>
